/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  DigiplaceCancelableRequest,
  DigiplaceCancelableResponse,
  PostAppDigiplaceDigiplacecancelableInvoke400,
  PostAppDigiplaceDigiplacecancelableInvoke401,
  PostAppDigiplaceDigiplacecancelableInvoke502,
} from '../placementApi.schemas.ts';

import postAppDigiplaceDigiplacecancelableInvokeMutator from '.././mutator/placement-instance.ts';

/**
 * Forwards a renunciation request to the Digiplace API for the contract identified by fiche_sf.
 * @summary Renounce a contract via Digiplace
 */
export const postAppDigiplaceDigiplacecancelableInvoke = (
  digiplaceCancelableRequest: DigiplaceCancelableRequest,
  signal?: AbortSignal
) => {
  return postAppDigiplaceDigiplacecancelableInvokeMutator<DigiplaceCancelableResponse>({
    url: `/api/digiplace/cancelable`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: digiplaceCancelableRequest,
    signal,
  });
};

export const getPostAppDigiplaceDigiplacecancelableInvokeMutationKey = () =>
  ['postAppDigiplaceDigiplacecancelableInvoke'] as const;

export const getPostAppDigiplaceDigiplacecancelableInvokeMutationOptions = <
  TError =
    | PostAppDigiplaceDigiplacecancelableInvoke400
    | PostAppDigiplaceDigiplacecancelableInvoke401
    | PostAppDigiplaceDigiplacecancelableInvoke502,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>,
    TError,
    PostAppDigiplaceDigiplacecancelableInvokeMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>,
  TError,
  PostAppDigiplaceDigiplacecancelableInvokeMutationVariables,
  TContext
> => {
  const mutationKey = getPostAppDigiplaceDigiplacecancelableInvokeMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>,
    PostAppDigiplaceDigiplacecancelableInvokeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return postAppDigiplaceDigiplacecancelableInvoke(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAppDigiplaceDigiplacecancelableInvokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>
>;
export type PostAppDigiplaceDigiplacecancelableInvokeMutationBody = DigiplaceCancelableRequest;
export type PostAppDigiplaceDigiplacecancelableInvokeMutationError =
  | PostAppDigiplaceDigiplacecancelableInvoke400
  | PostAppDigiplaceDigiplacecancelableInvoke401
  | PostAppDigiplaceDigiplacecancelableInvoke502;
export type PostAppDigiplaceDigiplacecancelableInvokeMutationVariables = { data: DigiplaceCancelableRequest };

/**
 * @summary Renounce a contract via Digiplace
 */
export const usePostAppDigiplaceDigiplacecancelableInvoke = <
  TError =
    | PostAppDigiplaceDigiplacecancelableInvoke400
    | PostAppDigiplaceDigiplacecancelableInvoke401
    | PostAppDigiplaceDigiplacecancelableInvoke502,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>,
      TError,
      PostAppDigiplaceDigiplacecancelableInvokeMutationVariables,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postAppDigiplaceDigiplacecancelableInvoke>>,
  TError,
  PostAppDigiplaceDigiplacecancelableInvokeMutationVariables,
  TContext
> => {
  return useMutation(getPostAppDigiplaceDigiplacecancelableInvokeMutationOptions(options), queryClient);
};
